import { Fragment } from 'react'

// Where a journey is: a node per stage joined by dashed edges. Signed stages are
// filled and their edge fills green once, the stage in hand wears a brand halo
// that pulses three times, the edge leaving it flows, a blocked stage is ringed
// critical and a declined one is marked. Nothing loops past five seconds.

export type TrackState = 'done' | 'current' | 'blocked' | 'rejected' | 'upcoming'

const NODE: Record<TrackState, string> = { done: 'd', current: 'c', blocked: 'b', rejected: 'x', upcoming: '' }

export function JourneyTrack({ states, label }: { states: TrackState[]; label: string }) {
  return (
    <div className="hc-mt" role="img" aria-label={label}>
      {states.map((st, i) => {
        const next = states[i + 1]
        let edge = ''
        if (st === 'done' && next && next !== 'upcoming') edge = 'd'
        else if (st === 'current' || st === 'blocked') edge = 'f'
        return (
          <Fragment key={i}>
            <span className={'node ' + NODE[st]} />
            {i < states.length - 1 && <span className={'edge ' + edge} />}
          </Fragment>
        )
      })}
    </div>
  )
}
